import { render } from "./terms_page.vue?vue&type=template&id=5e00e29a&scoped=true"
const script = {}

import "./terms_page.vue?vue&type=style&index=0&id=5e00e29a&lang=stylus&scoped=true"

import exportComponent from "/Volumes/KINDSTON/Lokal Google Drive/PROJECT/TECHSS/techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e00e29a"]])

export default __exports__